import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

var router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "Home",
      path: "/",
      component: () => import("./views/AL.ResetDeviceRegistrations.vue")
    },
    {
      name: "ResetDeviceRegistrations",
      path: "/resetdeviceregistrations",
      component: () => import("./views/AL.ResetDeviceRegistrations.vue")
    },
    {
      name: "Notices",
      path: "/notices",
      component: () => import("./views/AL.Notices.vue")
    },
    {
      name: "MqttShellCommand",
      path: "/shell",
      component: () => import("./views/AL.MqttShellCommand.vue")
    }
  ]
});

export default router;

